// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyDY6ytSCds0vdMcmpTgQlS-HQlnSGqpbVM",
    authDomain: "edunamica-44050.firebaseapp.com",
    databaseURL: "https://edunamica-44050.firebaseio.com",
    projectId: "edunamica-44050",
    storageBucket: "edunamica-44050.appspot.com",
    messagingSenderId: "962253683807",
    appId: "1:962253683807:web:0c7c6ed56546d56836efea",
    measurementId: "G-KWFNMED3KQ"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
